import React from 'react';
import {
  Col, Modal, Row,
} from 'antd';
import styled from 'styled-components';
import HTMLReactParser from 'html-react-parser';
import { maxMobile, wbSmartLaptop, wMBold } from 'Utils/utilsStyle';
import Empty from '../assets/svgIcons/Empty';

const Wrapper = styled.div`
`;

const Sup = styled.sup`
  font-size: 8px;
  font-weight: ${wMBold};
  letter-spacing: -0.17px;
  top: -29px;
  @media all and (max-width: ${maxMobile}) {
    top: -14px;
  }
`;

type Props = {
  description?: string,
  width?: string,
  onClickCancel?: () => void,
  showSmartContentPopup?: boolean,
} & typeof defaultProps;

const defaultProps = {
  description: '',
  width: '530px',
  onClickCancel() { },
  showSmartContentPopup: true,
};

const SmartSourcedContentPopup = function SmartSourcedContentPopup({
  description,
  width,
  onClickCancel,
  showSmartContentPopup,
}: Props) {
  const website = process.env.REACT_APP_WEBSITE;
  console.log(process.env);

  return (
    <Wrapper>
      <Modal
        open={showSmartContentPopup}
        centered
        width={width}
        closeIcon={<Empty />}
        getContainer=""
        wrapClassName="modal-c-widget smartContentPopupWrapper"
      >
        <Row style={{ height: '50%', width: '100%' }}>
          <Col span={12} xs={24} sm={12} md={12}>
            <div className="title text-left smart-content-title-div-center">
              <h4 className="text-left smart-content-heaing">
                <span className="the-title text-left">The</span>
                Smart Sourced
                <br />
                Content
                <Sup>TM</Sup>
              </h4>
            </div>
          </Col>
          <Col span={12} xs={24} sm={12} md={12}>
            <div className="img-div">
              <img src={wbSmartLaptop} alt="laptop" className="img-fluid" />
            </div>
          </Col>
        </Row>
        <p className="smartContentParagraph text-left">{description && HTMLReactParser(description)}</p>
        <div className="ant-modal-footer custom-footer">
          <span
            tabIndex={0}
            role="button"
            aria-label="book-a-meeting"
            className="button-book-meeting"
            onClick={() => window.open(website, '_blank')}
            onKeyPress={() => window.open(website, '_blank')}
          >
            Book a Meeting
          </span>
          <span
            tabIndex={0}
            role="button"
            aria-label="close"
            className="button-close-modal"
            onClick={onClickCancel}
            onKeyPress={onClickCancel}
          >
            Close
          </span>
        </div>
      </Modal>
    </Wrapper>
  );
};

SmartSourcedContentPopup.defaultProps = defaultProps;
export default SmartSourcedContentPopup;
